export class LoginDto {
  countryCode: string;
  phone: string;
  idi: number;
  tableCartId: number;
  constructor(countryCode: string, phone: string, idi: number, tableCartId: number) {
    this.countryCode = countryCode;
    this.phone = phone;
    this.idi = idi;
    this.tableCartId = tableCartId;
  }
}
